export default __webpack_public_path__ + "static/media/largedestructionpot.0fb78cc8.PNG";